module.exports = __webpack_public_path__ + "static/media/My Docs purple.13a2c4d8.png";